var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: this.$t("CargoMsg.Cargo_SetAMarginAlert2"),
            width: "480px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "140px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_MarginTip1") } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "1", min: 0, precision: 0 },
                        model: {
                          value: _vm.companyThresholdValue,
                          callback: function($$v) {
                            _vm.companyThresholdValue = $$v
                          },
                          expression: "companyThresholdValue"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_MarginTip2") } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "2", min: 0, precision: 0 },
                        model: {
                          value: _vm.userThresholdValue,
                          callback: function($$v) {
                            _vm.userThresholdValue = $$v
                          },
                          expression: "userThresholdValue"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }